import { gql } from '@apollo/client'
import Mail, { MailType } from 'globals/models/Mail'
import { Moment } from 'moment'

export const CREATE_MAIL = gql`
  mutation userMailCreate(
    $domiciliationId: ID!,
    $mailType: UserMailTypes!,
    $weight: Int,
    $sendName: String,
    $dateOfReceipt: ISO8601DateTime!,
    $scanFile: Upload
  ) {
    userMailCreate(
      domiciliationId: $domiciliationId,
      mailType: $mailType,
      weight: $weight,
      sendName: $sendName,
      dateOfReceipt: $dateOfReceipt,
      scanFile: $scanFile
    ) {
      userMail {
        id,
        createdAt,
        dateOfReceipt,
        forwardedAt,
        mailType,
        physicalLocation,
        physicallyDestroyedAt,
        processingDate,
        processingType,
        provisionedAt,
        queryDate,
        scanFile,
        scannedAt,
        sendName,
        thumbScanFile,
        weight
      }
    }
  }
`

export interface CreateMailVariables {
  domiciliationId: number,
  mailType: MailType,
  weight?: number,
  sendName?: string,
  dateOfReceipt?: string | Moment,
  scanFile?: File
}

export interface CreateMailResult {
  userMailCreate: {
    userMail: Mail
  }
}
